import { render, staticRenderFns } from "./CostsSection.vue?vue&type=template&id=05b1583f&scoped=true&"
import script from "./CostsSection.vue?vue&type=script&lang=js&"
export * from "./CostsSection.vue?vue&type=script&lang=js&"
import style0 from "./CostsSection.vue?vue&type=style&index=0&id=05b1583f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b1583f",
  null
  
)

export default component.exports